// extracted by mini-css-extract-plugin
export default {"button":"CreateEntityButton_button__XtJRV","disabled":"CreateEntityButton_disabled__elZat"};